<app-header-menu #headerMenu (clickScroll)="onClick($event)"></app-header-menu>
<ng-container *transloco="let t">
  <div class="header">
    <mat-icon [matMenuTriggerFor]="headerMenu.menu" class="menu">menu</mat-icon>
    <div class="app-logo" title="{{t('epson-logo-alt')}}" routerLink="/onboarding"></div>
    <div class="nav-left">
      <a id="a-benefits" (click)="onClick('benefits')"
        >{{ t('onboarding-benefits') }}</a
      >
      <a id="a-rewards" (click)="onClick('rewards')"
        >{{ t('onboarding-rewards') }}</a
      >
      <a id="a-categories" (click)="onClick('categories')"
        >{{ t('onboarding-categories') }}</a
      >
      <a id="a-faq" (click)="onClick('faq')">{{ t('onboarding-faq') }}</a>
      <a href="{{this.termsAndConditionsLink}}" target="_blank" rel="noopener"
        >{{t('onboarding-about')}}</a
      >
    </div>
    <div class="nav-right">
      <a id="a-createaccount" [routerLink]="'/'+RouterKeys.REGISTER"
        >{{ t('onboarding-createaccount') }}</a
      >
      <button
        id="button-login"
        [routerLink]="'/'+RouterKeys.LOGIN"
        mat-button-desktop
      >
        {{ t('goto-login') }}
      </button>
    </div>
  </div>
  <img
    src="/assets/images/faqheader.png"
    class="header-faq"
    alt="{{ t('people-working-alt') }}"
  />
  <a class="breadcrumb" routerLink="/onboarding">Home > FAQ</a>
  <h1 title id="faq">{{ t('landing-faq-title') }}</h1>
  <div class="faq">
    <div class="grid-faq">
      <div class="faq-container">
        <div class="faq-content">
          <div class="question">
            <h2 title>{{ t('landing-faq-q1') }}</h2>
            <p>{{ t('landing-faq-a1') }}</p>
            <hr />
          </div>
          <div class="question">
            <h2 title>{{ t('landing-faq-q2') }}</h2>
            <p>
              {{ t('landing-faq-a2') }}
              <strong>{{ t('landing-faq-a2-models') }}</strong>
            </p>
            <hr />
          </div>
          <div class="question">
            <h2 title>{{ t('landing-faq-q3') }}</h2>
            <ul>
              <li>
                <p>
                  {{ t('landing-faq-a3-1') }}
                  <a
                    href="{{t('landing-faq-a3-1-link')}}"
                    target="_blank"
                    rel="noopener"
                    >{{t('landing-faq-a3-1-link').slice(8)}}</a
                  >{{ t('landing-faq-a3-1-2') }}
                </p>
              </li>
              <li>
                <p>{{ t('landing-faq-a3-2') }}</p>
              </li>
              <li>
                <p>{{ t('landing-faq-a3-3') }}</p>
                <ul>
                  <li>
                    <p>{{ t('landing-faq-a3-4') }}</p>
                  </li>
                  <li>
                    <p>{{ t('landing-faq-a3-5') }}</p>
                  </li>
                </ul>
              </li>
            </ul>
            <p>{{ t('landing-faq-a3-6') }}</p>
          </div>
          <div class="question">
            <h2 title>{{ t('faq-q1') }}</h2>
            <ul>
              <li>
                <p>{{ t('faq-a1-1') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a1-2') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a1-3') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a1-4') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a1-5') }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="img">
        <img src="/assets/images/faq1.png" alt="{{ t('people-working-alt') }}" />
      </div>
    </div>
    <div class="grid-faq">
      <div class="img">
        <img src="/assets/images/faq2.png" alt="{{ t('people-working-alt') }}" />
      </div>
      <div class="faq-container">
        <div class="faq-content">
          <div class="question">
            <hr class="mobile" />
            <h2 title>{{ t('faq-q2') }}</h2>
            <ul>
              <li>
                <p>
                  {{ t('faq-a2-1') }}<a
                    href="{{t('landing-faq-a3-1-link')}}"
                    target="_blank"
                    rel="noopener"
                    >{{t('landing-faq-a3-1-link').slice(8)}}</a
                  >
                </p>
              </li>
              <li>
                <p>{{ t('faq-a2-2') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a2-3') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a2-4') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a2-5') }}</p>
              </li>
            </ul>
            <hr />
          </div>
          <div class="questionn">
            <h2 title id="contactUs">{{ t('faq-q3') }}</h2>
            <p>{{ t('faq-a3-1') }}</p>
            <ul>
              <li>
                <p>{{ t('faq-a3-2') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a3-3') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a3-4') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a3-5') }}</p>
              </li>
              <li>
                <p>{{ t('faq-a3-6') }}</p>
              </li>
            </ul>
          </div>
          <div class="question">
            <hr />
            <h2 title>{{ t('faq-q4') }}</h2>
            <p>
              {{ t('faq-a4') }}
              <a href="{{t('faq-a4-2')}}" target="_blank" rel="noopener"
                >{{t('faq-a4-2')}}</a
              >
            </p>
          </div>
          <button
            mat-button
            id="landing-start-now"
            [routerLink]="'/'+RouterKeys.REGISTER"
          >
            {{ t('landing-benefits-startnow') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="join-program">
    <div class="join-content">
      <div class="join-text-area">{{ t('onboarding-participate') }}</div>
      <div class="join-button-area">
        <button
          id="button-join-createaccount"
          join-button
          [routerLink]="'/'+RouterKeys.REGISTER"
        >
          {{ t('onboarding-createaccount') }}
        </button>
        <button
          id="button-join-login"
          join-button
          [routerLink]="'/'+RouterKeys.LOGIN"
        >
          Login
        </button>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="logos">
      <div class="app-logo" title="{{t('epson-logo-alt')}}"></div>
      <div class="label-powered-onboarding">
        Powered by
        <div class="epson-logo-onboarding">EPSON</div>
      </div>
    </div>
    <div class="copyright">
      <p>{{t('copyright')}}</p>
      <div>
        <a href="{{this.privacyPolicyLink}}" target="_blank" rel="noopener"
          >{{t('privacy-policy')}}</a
        >
        |
        <a href="{{this.termsAndConditionsLink}}" target="_blank" rel="noopener"
          >{{t('terms-conditions')}}</a
        >
      </div>
    </div>
  </div>
</ng-container>
